import type { FC, ReactNode } from "react";
import React from "react";

import { Column, Row } from "@jti/core-components/components/Row";

import styles from "./TwoColumnLayout.module.scss";

type TwoColumnLayoutProps = {
  children: ReactNode;
};

type SlotProps = {
  children: ReactNode;
};

type TwoColumnLayoutComponent = FC<TwoColumnLayoutProps> & {
  Header: FC<SlotProps>;
  Sidebar: FC<SlotProps>;
  Content: FC<SlotProps>;
};

export const TwoColumnLayout: TwoColumnLayoutComponent = ({ children }) => {
  let header: ReactNode = null;
  let sidebar: ReactNode = null;
  let content: ReactNode = null;

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement<{ children?: ReactNode }>(child)) return;

    if (child.type === TwoColumnLayout.Header) header = child.props.children;
    if (child.type === TwoColumnLayout.Sidebar) sidebar = child.props.children;
    if (child.type === TwoColumnLayout.Content) content = child.props.children;
  });

  return (
    <div className={styles.container}>
      {header}

      <Row className={styles.contentRow} dataTestId="two-column-layout-content-row">
        <Column lg={7} className={styles.mainSectionColumn} dataTestId="main-section">
          {content}
        </Column>

        <Column lg={5} className={styles.sideBarColumn} dataTestId="sidebar">
          {sidebar}
        </Column>
      </Row>
    </div>
  );
};

TwoColumnLayout.Header = function Header({ children }: { children: ReactNode }) {
  return <>{children}</>;
};

TwoColumnLayout.Sidebar = function Sidebar({ children }: { children: ReactNode }) {
  return <>{children}</>;
};

TwoColumnLayout.Content = function Content({ children }: { children: ReactNode }) {
  return <>{children}</>;
};
